/**
 * Converts ISO 8601 datetime string to standard display string
 * depending on user's system locale, also accounts for user's timezone
 *
 * i.e. "2021-07-20T16:12:14.765000+00:00" becomes "11:12 AM on 7/20/21"
 * for US central time user
 *
 * @param {string} isoDateString - ISO 8601 datetime string
 * @returns {string} Display string with format "[locale time] [AM|PM] on [locale date]"
 */
const isoStringDisplay = (isoDateString) => {
  const date = new Date(isoDateString);

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument
  const locale = 'en-US';

  const timeString = date.toLocaleTimeString(locale, {
    hour: 'numeric',
    minute: 'numeric',
  });
  const dateString = date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'numeric',
    year: '2-digit',
  });

  return `${timeString} on ${dateString}`;
};

export default isoStringDisplay;
